const openModal = ({ commit }) => {
  commit('SET_IS_MODAL_OPEN', true)
}

export default {
  openModal
}
